export default __webpack_public_path__ + "static/media/logo_inverted.08519c07.png";